<template>
	<div>
		<v-card elevation="0">
			<v-card-text>
				<div class="d-flex justify-space-between align-center">
          <tree-select
            v-model="ts_values"
            :auto-load-root-options=false
            :defaultExpandLevel="expand_level"
            :deleteRemoves="false"
            :disable-branch-nodes=false
            :load-options="getAllPdmTree"
            :multiple=true
            value-consists-of="LEAF_PRIORITY"
            :options="ts_options"
            :showCount=true
            :placeholder="$t('_selectionner_vos_points_de_mesure_')"
            @close="changePdm(ts_values)"
            @deselect="changePdm(ts_values)"
          >
            <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>
          </tree-select>
        </div>

        <div v-if="table_show">
          <v-row>
            <v-col class="col-sm-12">
              <v-dialog
                  v-model="hover_dialog"
                  max-width="550px"
                >
                <v-card>
                  <v-card-title>
                    <span>{{ $t('_details_des_sous_pertes_') }} : {{ pdm_name }}</span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text v-html="loss_details" />
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="col-sm-12">
              <v-flex :v-style="isOverflow">
                <v-data-table
                  v-if="table_show"
                  id="geo_pdm"
                  :headers="table_header"
                  :items="table_data"
                  :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),           
                  }"
                
                  :items-per-page=this.itemsPerPage
                  item-key="pdm_name"                 
                  dense
                >
                  <template v-slot:top>
                    <table class="d-flex justify-end">
                      <tr >
                        <td>
                          <v-switch
                              v-model="show_sub_loss"
                              :label="$t('_afficher_les_sous_pertes_')"
                          ></v-switch>
                        </td>
                        <td>
                          <v-toolbar
                            flat
                            dense
                          >
                            <v-btn-toggle
                              v-model="unit_filter"
                              dense
                              mandatory
                              rounded>
                              <v-btn :value="1">
                                <v-icon>mdi-percent</v-icon>
                              </v-btn>
                              <v-btn :value="2">
                                <v-icon>mdi-counter</v-icon>
                              </v-btn>
                              <v-btn :value="3">
                                <v-icon>mdi-cash-multiple</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-toolbar>
                        </td>
                      </tr>
                    </table>
                  </template>

                  <template v-slot:header="">
                    <th v-for="(head, idx_head) in table_header_sum" :key="idx_head + head" class="text-left global_sum">
                      <span class="table-text-sum">{{ head.text }}</span>
                    </th>
                  </template>

                  <template v-slot:body="{ items, headers }">
                    <tr v-for="(item, idx_item) in items" :key="idx_item">
                      <td v-for="(header, idx_head) in headers" :key="idx_head" class="text-left">
                        <v-hover
                            v-slot:default="{ hover }"
                            v-if="header['node_type'].includes('sub_loss') && header['tips'].length > 0">
                          <v-badge :value="hover" color="blue accent-4" :content="'Catégorie : ' + header['tips']" left transition="slide-x-transition">
                            <span class="table-text">{{ item[header.id] }}</span>
                          </v-badge>
                        </v-hover>
                        <div v-else>
                          <span class="table-text">{{ item[header.id] }}</span>
                        </div>
                      </td>
                    </tr>
                  </template>

                </v-data-table>
              </v-flex>
            </v-col>
          </v-row>
          <v-btn @click="downloadData()">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>
				</div>
        
			</v-card-text>
		</v-card>
	</div>
</template>

<script>

// import webconf from "../../utils/frontend_setup";

import api from "@/api/api";
import cd from '@/utils/compute_data.js';
import TreeSelect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';


export default {
	components: {
    TreeSelect
	},

	data() {
		return {
      script_name: "Subarrays.vue (Dashboard Niv2)",        // For debug
      installation_id: this.$route.params.id,
			current_pdm: null,
      expand_level: null,
      hover_dialog: false,
      isOverflow: '',
      loss_details: '',
      pdm_name: '',
      table_header: null,
      table_header_qry: null,
      table_header_sum: null,
      table_header_sum_qry: null,
      table_data: null,
      table_data_qry: null,
      table_show: false,
      table_sub_loss_data: null,
      ts_values: null,
      ts_options: [],
      unit_filter: 2,
      show_sub_loss: false,   
      itemsPerPage: 20,
		};
	},

	watch: {
		route: {
			async handler() {
        await this.getAllPdmTree()
      },
			immediate: true,
		},

    dates: {
      async handler() {
        await this.renderSubarrayTable()
      },
      deep: true,
    },

    ts_values: {
      async handler() {
        if (this.ts_values === undefined || this.ts_values === null || this.ts_values.length === 0) {
          this.table_show = false
          // If we want to reset pdm list when clic on sub-array tab
          this.$store.dispatch("setGeoPdm", {pdm_list: ''})
        } else {
          this.table_show = true
          await this.renderSubarrayTable()
        }
      },
      immediate: true,
    },

    unit_filter: {
      handler() {
        this.filterSubarrayTable()
      },
      // immediate: true,
    },

    show_sub_loss: {
      async handler() {
        this.filterSubarrayTable()
      },
      // immediate: true,
    },

	},

  computed: {
    dates() {
			return this.$store.state.parametersStore.dates;
		},      

  },

	methods: {  
    downloadData(){

      api.convertJson({
        "data" : {"input": this.table_data}, 
        "header": this.table_header}, 
        "xlsx", this.$root.$i18n.locale, "data_table")
        .then((res)=>{
          let name = "tableau_pdm_geo_"+ this.$route.params.id + ".xlsx"
          let a = document.createElement('a');
          a.href = URL.createObjectURL(res.data) ;
          a.download = name;
          a.click();}
        )
    },

    geo_pdm() {
      // console.log('get computed geo_pdm')
      const val_geo_pdm = this.$store.getters.geo_pdm

      return (val_geo_pdm !== undefined && val_geo_pdm !== null && val_geo_pdm.length > 0)
          ? this.$store.getters.geo_pdm.split(',') : []
    },

    async changePdm(pdm_list) {
      if (pdm_list !== undefined && pdm_list !== null) {
        // console.log('changePdm : set geo_pdm')
        this.ts_values.sort()
        pdm_list.sort()
        this.$store.dispatch("setGeoPdm", {pdm_list: pdm_list})
        await this.renderSubarrayTable()
      } else {
        // console.log('changePdm : reset geo_pdm')
        this.ts_values = []
        this.$store.dispatch("setGeoPdm", {pdm_list: ''})
        this.table_show = false
      }
    },

    async getAllPdmTree() {
      const langcode = this.$root.$i18n.locale

      await api
        .getPdmTree(this.installation_id, langcode)
        .then((res) => {
          res.data['tree'].map((elm) => this.ts_options.push(elm));
          this.expand_level = res.data['expand_level']
        });
    },

    async renderSubarrayTable() {

      this.table_show = false
      this.table_header = []
      this.table_data = []

      if (this.$store.getters.geo_pdm === null) return
      if (this.$store.getters.geo_pdm.length === 0) return

      const pdm_list_key = this.$store.getters.geo_pdm.split(',').map(pdm => cd.parsePdmId(pdm)).join(',')

			await api
				.getInstallationSubarrayTable(this.$route.params.id, {
					start_date: this.dates.start,
					end_date: this.dates.end,
					time_step: this.$store.getters.geo_timestep,
          pdm_list: pdm_list_key,
          export_row_data: false,
          country_lang_code: this.$root.$i18n.locale,
          pn_type:"mpp"
        }).then((res) => {
            // Translate header
            let header = res.data['header']
            for (let i = 0; i < header.length; i++) {
              const s = header[i].text.split('_ ')
              header[i].text = (s.length > 1) ? this.$t(`${s[0]}_`) + ' (' + this.$t(s[1]) + ')' : this.$t(header[i].text)
            }
            this.table_header_qry = header

            // Translate Header sum
            let header_sum = res.data['header_sum']
            for (let i = 0; i < header_sum.length; i++) {
              header_sum[i].text = (typeof header_sum[i].text !== "number") ? this.$t(header_sum[i].text) : header_sum[i].text
            }
            this.table_header_sum_qry = header_sum

            this.table_data_qry = res.data['row_data']

            this.filterSubarrayTable()
				})
		},

    filterSubarrayTable() {
  this.table_show = false;

  let tunit = '';
  let unit_suffix = '';
  switch (this.unit_filter) {
    case 1:
      tunit = 'percent';
      unit_suffix = '_pct';
      break;
    case 2:
      tunit = 'kwh';
      unit_suffix = '';
      break;
    case 3:
      tunit = 'currency';
      unit_suffix = '_cur';
      break;
  }

  // Initialize table header and sum arrays
  this.table_header = [];
  this.table_header_sum = [];
  //let validColumns = [];

  // Step 1: Filter valid columns based on the unit and node_type
  for (let idx = 0; idx < this.table_header_qry.length; idx++) {
    let node_type = this.table_header_qry[idx]['node_type'];
    if (
      ((this.show_sub_loss && node_type.includes('sub_loss'))
        || (!this.show_sub_loss && node_type.includes('loss'))
        || node_type.includes('common'))
      && (this.table_header_qry[idx]['unit'] === tunit
          || (node_type.includes('common') && this.table_header_qry[idx]['unit'] === null))
    ) {
      this.table_header_qry[idx]['tips'] = this.$t(this.table_header_qry[idx]['tips']);
      this.table_header.push(this.table_header_qry[idx]);
      this.table_header_sum.push(this.table_header_sum_qry[idx]);
     // validColumns.push(this.table_header_qry[idx]['id']);
    }
  }

  // Step 2: Filter data based on valid columns
  this.table_data = [];
  this.table_data_qry.forEach((data) => {
    let data_item = {};
    for (let idx_header = 0; idx_header < this.table_header.length; idx_header++) {
      const fieldName = this.table_header[idx_header]['id'];
      if (data[fieldName] !== undefined && data[fieldName] !== null) {
        data_item[fieldName] = data[fieldName];
      }
    }
    this.table_data.push(data_item);
  }); 

  // Step 4: Update data rows with the computed sums
  for (let idx_data = 0; idx_data < this.table_data.length; idx_data++) {
    let row_sum = 0;
    for (let idx_header = 0; idx_header < this.table_header.length; idx_header++) {
      let node_type = this.table_header[idx_header]['node_type'];
      let id = this.table_header[idx_header]['id'];

      if (node_type.includes('loss') || node_type.includes('sub_loss')) {
        // Ensure the value is numeric before adding it to the sum
        const value = this.table_data[idx_data][id];
        if (value !== null && !isNaN(value)) {
          row_sum += parseFloat(value);
          
        }
      }
      if (id.includes(`sum_losses${unit_suffix}`)) {
        // Update the sum column for each row
        this.table_data[idx_data][`sum_losses${unit_suffix}`] = Math.round(row_sum * 10) / 10;
      }
    }
  }

  // Step 5: Ensure global sum column is included (even if it has no data)
  this.table_header = this.table_header.filter((header) => {
    let hasData = this.table_data_qry.some((data) => data[header['id']] !== undefined && data[header['id']] !== null);
    // Always include global sum column (adjust this condition based on your column ID or name)
    if (header['id'].includes('sum_losses') || hasData) {
      return true;
    }
    return false;
  });
  this.table_header_sum = this.table_header_sum.filter((header) => {
    let hasData = this.table_data_qry.some((data) => data[header['value']] !== undefined && data[header['value']] !== null);
    // Always include global sum column (adjust this condition based on your column ID or name)
    if (header['value'].includes('sum_losses') || hasData) {
      return true;
    }
    return false;
  });
  
 // Step 3: Compute row sums including the global sum
 let global_sum = 0;
  for (let idx_header = 0; idx_header < this.table_header.length; idx_header++) {   
    let node_type = this.table_header[idx_header]['node_type'];
    let id = this.table_header[idx_header]['id'];

    if (node_type.includes('loss') || node_type.includes('sub_loss')) {
      // Check if the column contains data
      if (!isNaN(this.table_header_sum[idx_header]['text'])) {        
         global_sum += parseFloat(this.table_header_sum[idx_header]['text']);        
      }  
    }
    if (id.includes('sum_losses')) {
      // Ensure sum value is correctly calculated    
     
      this.table_header_sum[idx_header]['text'] = Math.round(global_sum * 10) / 10;
     
    }
    
  }

  
 

  this.table_show = true;
}

	},
};
</script>

<style scoped>
.level-1-table thead {
  vertical-align: middle;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  font-size: .75rem;
  height: 45px;
  line-height: 1.2;
}

.v-data-table td,
.v-data-table th {
  padding: 10px;
}

.v-data-table-header th {
  background-color: #f7f7f7;
}

/* .v-data-table-header {
  height: 120px;
  vertical-align: middle;
} */

.table-text {
  font-family: Roboto,sans-serif;
  font-size: .75rem;
  font-weight: 400;
  text-align: left;
}

.table-text-sum {
  font-family: Roboto,sans-serif;
  font-size: .75rem;
  font-weight: 600;
  text-align: left;
  color: #1976d2;
}
.global_sum {
  border-bottom: #cfcfcf solid 1px;
}

</style>